import { render, staticRenderFns } from "./HistoryUserMasseuse.vue?vue&type=template&id=e62f8af6&scoped=true&"
import script from "./HistoryUserMasseuse.vue?vue&type=script&lang=js&"
export * from "./HistoryUserMasseuse.vue?vue&type=script&lang=js&"
import style0 from "./HistoryUserMasseuse.vue?vue&type=style&index=0&id=e62f8af6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62f8af6",
  null
  
)

export default component.exports